module.exports = __webpack_public_path__ + "static/media/traycorp4.539abf1a.png";